<template>
  <div class="content" style="background-color: #bae3f8">
    <div class="mark_start" v-if="mark_start" ></div>

    <div class="view">
      <el-button type="text" class="backBtn" @click="onBack()"
        >&nbsp;</el-button
      >
      <el-dropdown trigger="click" class="btns_1" @command="btns1Handle">
        <el-button style="width: 80px" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in xlfs"
            :key="index"
            :command="item.value"
            >{{ item.key }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" class="btns_2" @command="btns2Handle">
        <el-button style="width: 80px" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in xljb"
            :key="index"
            :command="item.value"
            >{{ item.key }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" class="btns_3" @command="btns3Handle">
        <el-button style="width: 80px" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in bgType"
            :key="index"
            :command="item.value"
            >{{ item.key }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" class="btns_4" @command="btns4Handle">
        <el-button style="width: 80px" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in bgColor"
            :key="index"
            :command="item.value"
            >{{ item.key }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" class="btns_5" @command="btns5Handle">
        <el-button style="width: 80px" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in bgSize"
            :key="index"
            :command="item.value"
            >{{ item.key }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" class="btns_6" @command="btns6Handle">
        <el-button style="width: 80px" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in bgSpeed"
            :key="index"
            :command="item.value"
            >{{ item.key }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" class="btns_7" @command="btns7Handle">
        <el-button style="width: 80px" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in bh"
            :key="index"
            :command="item.value"
            >{{ item.key }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        type="text"
        class="startBtn"
        :disabled="startBtn"
        @click="start"
        >&nbsp;</el-button
      >
      <el-button
        type="text"
        class="voicePaly"
        :disabled="disabled"
        @click="voicePaly()"
        >&nbsp;</el-button
      >
      <el-button
        type="text"
        class="voiceClose"
        :disabled="disabled"
        @click="voiceClose()"
        >&nbsp;</el-button
      >
      <!--      <el-button type="text" class="bigWindow" :disabled="disabled" @click="bigWindow()">&nbsp;</el-button>-->
      <el-dropdown
        trigger="click"
        class="bigWindow"
        :disabled="disabled"
        @command="bigWindow"
      >
        <el-button style="width: 40px;height: 40px" size="mini" type="text">
          &nbsp;
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="'全屏模式'"
            >{{ "全屏模式" }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button @click="prev" type="text" :disabled="disabled" class="prevBtn"
        >&nbsp;</el-button
      >
      <el-button @click="next" type="text" :disabled="disabled" class="nextBtn"
        >&nbsp;</el-button
      >
      <div class="time" v-show="timeShow">{{ time }} <span>s</span></div>
      <div class="count" v-show="countShow">{{ count }}</div>
      <div class="shadow" v-show="countShow || !timeShow"></div>
    </div>
    <audio ref="audio" :src="audioUrl" loop></audio>
    <div class="fullScreen" :style="fullScreenDiv">
      <h2 style="position: relative;top:25%;left: 44%;color: red;width: 300px;">
        本次剩余时间：{{ time }}S
      </h2>
      <h1
        v-show="countShow"
        style="position: relative;top:22%;left: 87%;color: #54ff00"
      >
        {{ count }}
      </h1>
      <el-button style="position: relative;top:80vh;left: 90%" @click="outFull"
        >退出全屏</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import { closeCount, setCount, startCount,timeCount } from "./timeCount/index.js";

import dlConfig from "./dlConfig.js";
export default {
  name: "dlView",
  components: {},
  data: function() {
    return {
      mark_start: true,
      fullScreenDiv: "display:none",
      audioUrl: `/static/mp3/Track${Math.ceil(Math.random() * 9 + 1)}.mp3`,
      xlfs: [],
      xljb: [],
      bgType: [],
      bgColor: [],
      bgSize: [],
      bgSpeed: [],
      bh: [],
      xlfsStr: "描点",
      xljbStr: "初级",
      bjfsStr: "",
      bjysStr: "",
      bjdxStr: "",
      bjsdStr: "",
      bhcxStr: "",
      page: 0,
      time: 180,
      timeShow: false,
      count: 100,
      countShow: false,
      timerObj: {},
      disabled: true,
      fullscreen: false,
      startBtn: false,
      isEnd: false
    };
  },
  created() {
    window.onresize = () => {
      if (!this.checkFull()) {
        // 退出全屏后要执行的动作
        console.log("退出全屏");
        this.outFull();
        this.fullscreen = false;
      }
    };
    window.dlViewMessage = data => {
      console.log("111111111111111111aaaa=>", data);
      let {
        data: { msg, action, uuid }
      } = data;
      if (action === "computeRate") {
        console.log(data);
        this.count = (parseFloat(msg) * 100).toFixed(0);
        this.mark_start = true
        debugger;
      }
      if(action === "runTrain"){
        this.mark_start = false
      }
      if(uuid == 'bgLoad' && action == 'bgLoadFinish'){
        this.setTime();
        this.mark_start = false
        if(!this.mark_start){
          this.timerStart();
        }
      }
      if (uuid === "sys") {
        if (this.page === 9) {
          this.disabled = true;
          this.countShow = true;
          this.next();
          this.$store.commit('closeCount')
          // clearInterval(this.timerObj);
          return;
        }
        this.disabled = true;
        this.countShow = true;
          this.$store.commit('closeCount')

        // clearInterval(this.timerObj);
        setTimeout(() => {
          this.disabled = false;
          this.page = this.page + 1;
          this.countShow = false;
          this.setTime();
          this.timerStart();
          this.sendMessage();
        }, 3000);
      }
      if (uuid === "prev") {
        this.disabled = true;
        this.countShow = true;
        this.startBtn = true;
        this.$store.commit('closeCount')
        // clearInterval(this.timerObj);
        setTimeout(() => {
          this.disabled = false;
          this.page = this.page - 1;
          this.countShow = false;
          this.setTime();
          this.timerStart();
          this.sendMessage();
          this.startBtn = false;
        }, 3000);
      }
      if (uuid === "next") {
        this.disabled = true;
        this.countShow = true;
        this.startBtn = true;
          this.$store.commit('closeCount')

        // clearInterval(this.timerObj);
        if (this.page !== 9) {
          setTimeout(() => {
            this.disabled = false;
            this.page = this.page + 1;
            this.countShow = false;
            this.setTime();
            this.timerStart();
            this.sendMessage();
            this.startBtn = false;
          }, 3000);
        } else {
          this.startBtn = false;
        }
      }
    };
    window.addEventListener("message", window.dlViewMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", window.dlViewMessage);
    let payload1 = { uuid: "bg", action: "runBg", data: ["asd", "", "", ""] };
    window.tvView.contentWindow.postMessage(payload1, "*");
    this.time = 180;
    this.$store.commit('closeCount')
  },
  mounted() {
    // // 添加键盘Esc事件
    // this.$nextTick(() => {
    //   document.addEventListener("keyup", e => {
    //     if (e.keyCode == 27) {
    //     }
    //   });
    // }),
          this.$store.commit('closeCount')

    // clearInterval(this.timerObj);
    this.time = 180;
    let payload = { uuid: "bg", action: "runBg", data: ["", "", "", ""] };
    window.tvView.contentWindow.postMessage(payload, "*");
    window.tvView.contentWindow.postMessage(
      { uuid: "conut", action: "setDrawSize", data: ["5"] },
      "*"
    );
    this.getDLConfig();
    let fn = () => {
      if (window.initDone) {
        this.sendMessage(false);
      } else {
        setTimeout(() => {
          fn();
        }, 200);
      }
    };
    fn();
  },
  watch: {
    xlfsStr(val) {
      let dl = this.$route.query.flag;
      if (this.xlfsStr == "描图") {
        console.log(this.$route.query.flag, "描图");
        this.bh = [{ key: "粗", value: "10" }];
        let payload = {
        uuid: "conut",
        action: "setDrawSize",
        data: [10]
      };
      window.tvView.contentWindow.postMessage(payload, "*");
      } else {
        this.bh = dlConfig.bh[dl];
      }
    },
    bjfsStr(val) {
      let dl = this.$route.query.flag;
      if (dl === "flag3" && val === "扫描") {
        this.bgSize = [
          { key: "1", value: "9" },
          { key: "2", value: "8" },
          { key: "3", value: "7" },
          { key: "4", value: "6" },
          { key: "5", value: "5" },
          { key: "6", value: "4" },
          { key: "7", value: "3" },
          { key: "8", value: "2" },
          { key: "9", value: "1" }
        ];
      } else if (dl === "flag4" && val === "旋转2") {
        this.bgSize = [{ key: "9", value: "1" }];
      } else if (dl === "flag4" && val === "发射2") {
        this.bgSize = [{ key: "9", value: "1" }];
        window.aaasss = "99";
        this.btns5Handle(1);
      } else {
        this.bgSize = dlConfig.bgSize[dl];
      }
    },
    '$store.state.timeDown.timeCount'(old1,new1){
      this.time = new1
      if(new1 <= 0){
        this.time = 0
      }
    },
    time(){
      if(this.time == 1){
        this.$store.commit('closeCount')
        this.timeOver()
      }
    }
  },
  computed: {
    ...mapGetters([]),
   
  },
  methods: {
    ...mapActions(["saveFullScreen"]),
    // 判断全屏
    checkFull() {
      //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      //火狐浏览器
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        //谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    outFull() {
      document.exitFullscreen();
      this.fullScreenDiv = "display:none";
      this.fullscreen = false;
      this.saveFullScreen(this.fullscreen);
    },
    bigWindow() {
      let element = document.documentElement;
      // 判断是否已经是全屏
      // 如果是全屏，退出
      // 否则，进入全屏
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
      }
      this.fullScreenDiv = "display:block";
      this.fullscreen = true;
      this.saveFullScreen(this.fullscreen);
    },
    setBg() {
      // let payload1 = {uuid: 'bg', action: 'runBg', data: ['asd', this.bjysStr, this.bjsdStr, this.bjdxStr]}
      // window.tvView.contentWindow.postMessage(payload1, '*')
      if (this.disabled === false) {
        let payload = {
          uuid: "bg",
          action: "runBg",
          data: [this.bjfsStr, this.bjysStr, this.bjsdStr, this.bjdxStr]
        };
        window.tvView.contentWindow.postMessage(payload, "*");
        console.log('window',window);
      }
    },
    timeOver() {
      this.$alert("时间到", "提示", {
        confirmButtonText: "确定"
      })
        .then(() => {
          console.log(this.page);
          // this.countShow = true;
          this.next();
        })
        .catch(() => {
          // this.countShow = true;
          this.next();
        });
    },
    timerStart() {
      this.timeShow = true;
      this.$store.commit('closeCount')
      this.$store.commit('startCount')
      // clearInterval(this.timerObj);
      // this.timerObj = setInterval(() => {
      //   this.time -= 1;
      //   console.log(this.time, "time");
      //   if (this.time === 0) {
      //     this.timeOver();
      //     clearInterval(this.timerObj);
      //   }
      // }, 1000);
    },
    start() {
      this.countShow = false;
      this.disabled = false;
      if (this.isEnd) {
        this.page = 0;
      }
      this.voicePaly();
      clearInterval(this.timerObj);
      this.$store.commit('closeCount')
      setTimeout(() => {
        this.setBg();
        this.sendMessage();
         if(!this.mark_start){
           this.setTime()
          this.timerStart();
        }
      }, 200);
    },
    onBack() {
      window.history.back();
    },
    voicePaly() {
      console.log(this.audioUrl);
      this.$refs.audio.play();
    },
    voiceClose() {
      this.$refs.audio.pause();
    },
    getDLConfig() {
      let dl = this.$route.query.flag;
      this.xlfs = dlConfig.xlfs[dl];
      this.xljb = dlConfig.xljb[dl];
      this.bgType = dlConfig.bgType[dl];
      this.bgColor = dlConfig.bgColor[dl][this.bgType[0].value];
      this.bgSize = dlConfig.bgSize[dl];
      this.bgSpeed = dlConfig.bgSpeed[dl];
      this.bh = dlConfig.bh[dl];
      this.bjfsStr = this.bgType[0].value;
      this.bjysStr = this.bgColor[0].value;
      this.bjdxStr = this.bgSize[0].value;
      this.bjsdStr = this.bgSpeed[0].value;
    },
    btns1Handle(command) {
      console.log(command, "训练方式");
      this.xlfsStr = command;
      this.setTime();
      this.page = 0;
      this.countShow = false;
      // this.start()// 关闭选择训练方式后自动开始训练
      this.sendMessage();
    },
    btns2Handle(command) {
      console.log(command, "训练级别");

      this.xljbStr = command;
      this.setTime();
      this.page = 0;
      this.countShow = false;
      //this.start()// 关闭自动开始训练
      this.sendMessage();
    },
    btns3Handle(command) {
      let dl = this.$route.query.flag;
      this.bjfsStr = command;
      this.bgColor = dlConfig.bgColor[dl][command];
      this.bjysStr = this.bgColor[0].value;
      this.mark_start = true
      clearInterval(this.timerObj);
      this.$store.commit('closeCount')
      this.setTime();
      this.setBg();
    },
    btns4Handle(command) {
      console.log(command, "背景颜色");

      this.bjysStr = command;
      this.setBg();
    },
    btns5Handle(command) {
      console.log(command, "背景大小");

      this.bjdxStr = command;
      this.setBg();
    },
    btns6Handle(command) {
      console.log(command, "背景速度");
      this.bjsdStr = command;
      this.setBg();
    },
    btns7Handle(command) {
      console.log(command, "笔画粗细");
      this.bhcxStr = command;
      let payload = {
        uuid: "conut",
        action: "setDrawSize",
        data: [this.bhcxStr]
      };
      window.tvView.contentWindow.postMessage(payload, "*");
    },
    prev() {
      this.$store.commit('closeCount')
      // clearInterval(this.timerObj);
      this.setTime();
      if (this.page !== 0) {
        let payload = { uuid: "prev", action: "computeRate", data: [] };
        window.tvView.contentWindow.postMessage(payload, "*");
      } else {
        this.$message({
          showClose: true,
          message: "已经是第一个训练了",
          type: "warning"
        });
      }
    },
    next() {
      this.$store.commit('closeCount')
      // clearInterval(this.timerObj);
      this.setTime();
      if (this.page === 9) {
        this.isEnd = true;
        this.$message({
          showClose: true,
          message: "已经是最后一个训练了",
          type: "warning"
        });
      }
      let payload = { uuid: "next", action: "computeRate", data: [] };
      window.tvView.contentWindow.postMessage(payload, "*");
    },
    sendMessage() {
      console.log("sendMessage=>");
      let view = {
        flag1: "训练一",
        flag2: "训练二",
        flag3: "训练三",
        flag4: "训练四"
      };
      let payload = {
        uuid: "aaaa",
        action: "runTrain",
        data: [
          `${view[this.$route.query.flag]},${this.xlfsStr},${this.xljbStr},${
            this.page
          }`,
          true
        ]
      };
      window.tvView.contentWindow.postMessage(payload, "*");
    },
    setTime() {
      let setTimeS = { 初级: 180, 中级: 300, 高级: 480 };
      // this.time = setTimeS[this.xljbStr];
      this.$store.commit('setCount',setTimeS[this.xljbStr])
    }
  }
};
</script>
<style scoped lang="css">
.view {
  width: 1024px;
  height: 768px;
  background-image: url("../static/img/dl/dl.png");
      position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -520%);
    transform: translate(-50%, -50%);
}
.mark_start{
   width: 700px;
    height: 600px;
    position: absolute;
    background-color: red;
    opacity: 0;
    top: 60%;
    left: 55%;
    -webkit-transform: translate(-50%, -520%);
    transform: translate(-50%, -50%);
    z-index: 100;
}
.voicePaly {
  position: relative;
  top: 7px;
  left: -265px;
  width: 40px;
  height: 40px;
  background-color: transparent;
}

.bigWindow {
  position: relative;
  top: 35px;
  left: -125px;
  width: 40px;
  height: 40px;
  background-color: transparent;
}

.voiceClose {
  position: relative;
  top: -20px;
  left: -174px;
  width: 40px;
  height: 40px;
  background-color: transparent;
}

.startBtn {
  position: relative;
  top: 40px;
  left: -303px;
  width: 149px;
  height: 63px;
  background-color: transparent;
}

.prevBtn {
  position: relative;
  top: 665px;
  left: -400px;
  width: 90px;
  height: 40px;
  background-color: transparent;
}

.nextBtn {
  position: relative;
  top: 595px;
  left: 640px;
  width: 90px;
  height: 40px;
  background-color: transparent;
}

.backBtn {
  position: relative;
  top: 41px;
  left: 44px;
  width: 69px;
  height: 100px;
  background-color: transparent;
}

.btns_1 {
  position: relative;
  top: 6px;
  left: 100px;
}

.btns_2 {
  position: relative;
  top: 93px;
  left: 18px;
}

.btns_3 {
  position: relative;
  top: 181px;
  left: -120px;
}

.btns_4 {
  position: relative;
  top: 310px;
  left: -290px;
}

.btns_5 {
  position: relative;
  top: 403px;
  left: -313px;
}

.btns_6 {
  position: relative;
  top: 578px;
  left: -350px;
}

.btns_7 {
  position: relative;
  top: 645px;
  left: -500px;
}

.el-button--text {
  padding: 10px
}

.time {
  width: 100px;
  position: relative;
  top: 300px;
  left: 232px;
  color: red;
  font-size: 24px;
  text-align: center;
}

.count {
  background-image: url('../static/img/dl/score.png');
  width: 105px;
  height: 44px;
  border-radius: 15px;
  text-align: center;
  line-height: 40px;
  font-size: 30px;
  position: relative;
  top: -130px;
  left: 85%;
}

.shadow {
  width: 585px;
  height: 370px;
  position: relative;
  z-index: 5;
  top: 90px;
  left: 340px;
  border-radius: 30% / 35%;
  background-color: transparent;
}

.fullScreen {
  position: absolute;
  background-color: #000;
  width: 100%;
  height: 100%;
}
</style>
